// Path: ./src/app/components/MultiSelectDropDown/styled.ts
import styled from "styled-components";
import { styled as MuiStyled, Select } from "@mui/material";
interface WrapperProps {
  wrapperStyle?: string;
}
export const Wrapper = styled.div<WrapperProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: start;
  ${({ wrapperStyle }) => wrapperStyle || ""}
`;

export const CssMultiSelect = MuiStyled(Select<string[]>)({
  "& .MuiSelect-select": {
    borderRadius: 10,
    backgroundColor: "white",
    padding: 6,
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#dedede",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "#fd954f",
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#fd954f",
  },
});

interface TextProps {
  textCss?: string;
}
export const Text = styled.div<TextProps>`
  margin-left: 8px;
  ${({ textCss }) => textCss || ""}
`;
